<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t("vincular-cliente") }}
                    </h1>
                </div>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="clientesSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-cliente"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="clientes"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="clientesSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idcliente === linha.idcliente"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssClienteEmpresaService from '@/services/vendas/empresa/abas/AssClienteEmpresaService';

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idempresa: 0,
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    data() {
        return {
            service: new AssClienteEmpresaService(this.$http, this.$router),
            clientes: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'idclienteerp', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
            ],
            clientesSelecionados: [],
            idusuario: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],

            isVenda: this.$route.meta.contexto == "vendas",
            isPromotor: this.$route.meta.contexto == "promotor",
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findClientesNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idempresa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.clientes = value;
                this.isEmpty = this.clientes.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findClientesNaoAssociados(column, order, page, limit, idempresa, ...params) {
            if(this.isVenda) {
                return this.service
                .findClientesNaoAssociadosVendas(column, order, page, limit, idempresa, ...params);
            }else if(this.isPromotor) {
                return this.service
                .findClientesNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params);
            }else {
                return this.service
                .findClientesNaoAssociadosAgro(column, order, page, limit, idempresa, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            if(this.isPromotor) {
                return body.content.map(m => {
                    return {
                        idcliente: m.idcliente,
                        idempresa: this.idempresa,
                        idclienteerp: m.idclienteerp,
                        nome: m.nome,
                        rsocial: m.rsocial,
                    };
                });
            }else {
                return body.content.map(m => {
                    return {
                        idcliente: m.idcliente,
                        idempresa: this.idempresa,
                        idclienteerp: m.idclienteerp,
                        nome: m.nome,
                        rsocial: m.rsocial,
                    };
                });
            }
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value.replace(/[./-]+/g, ''));
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.clientesSelecionados.length > 0) {
                this.isLoading = true;

                this.saveCliente()
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },
        saveCliente() {
            if (this.isVenda) return this.service.saveVendas(this.clientesSelecionados);
            else if (this.isPromotor) return this.service.savePromotor(this.clientesSelecionados);
            else return this.service.saveAgro(this.clientesSelecionados);
        },
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
